<template>
  <header class="bg-white border-b border-base-300 flex items-center px-8 py-4">
    <BambeeLogo class="flex-shrink-0 lg:hidden mr-4" />
    <component
      :is="breadcrumbComponent"
      tag="h1"
      :variant="$screen.lg ? 'medium' : 'small'"
      :weight="$screen.lg ? 'regular' : 'regular'"
    >
      <portal-target name="crumbs" />
    </component>
    <div class="ml-auto relative inline-block">
      <button
        type="button"
        class="flex items-center justify-center w-12 h-12 rounded hover:bg-base-100 transition-colors"
        @click="goToNotifications"
      >
        <svg
          class="w-7 h-7 text-base-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
          />
        </svg>
      </button>
      <span
        v-if="notificationCount > 0"
        class="absolute top-1 right-1 flex items-center justify-center w-5 h-5 text-10 font-semibold text-white bg-error-default rounded-full border-2 border-white pointer-events-none"
      >
        {{ notificationCount }}
      </span>
    </div>
    <!-- Feature flag 'display-hr-requests-in-left-nav' removed - was always FALSE in production -->
    <HeaderAdvisorPanel />
    <HamburgerButton
      class="lg:hidden ml-3 relative z-10"
      :open="isNavOpen"
      @click="$emit('toggle-nav')"
    />
    <NavOverlay :is-nav-open="isNavOpen" />
  </header>
</template>

<script>
import BambeeLogo from '@/components/BambeeLogo/BambeeLogo.vue';
import NavOverlay from '@/components/default-layout/NavOverlay';
import { HamburgerButton, TypeBody, TypeDisplay } from '@bambeehr/pollen';

const HeaderAdvisorPanel = () =>
  import('@/components/default-layout/HeaderAdvisorPanel');

export default {
  components: {
    BambeeLogo,
    HamburgerButton,
    HeaderAdvisorPanel,
    NavOverlay,
  },
  props: {
    isNavOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      notificationCount: 0,
    };
  },
  computed: {
    breadcrumbComponent() {
      return this.$screen.lg ? TypeDisplay : TypeBody;
    },
  },
  mounted() {
    // Listen for notification count updates from Nuc iframe
    window.addEventListener('message', this.handleNotificationCountUpdate);
  },
  beforeUnmount() {
    // Clean up event listener
    window.removeEventListener('message', this.handleNotificationCountUpdate);
  },
  methods: {
    handleNotificationCountUpdate(event) {
      // Verify message origin and format
      if (
        event.data &&
        event.data.type === 'notifications:count-updated' &&
        typeof event.data.payload === 'object'
      ) {
        const { count } = event.data.payload;
        if (typeof count === 'number') {
          this.notificationCount = count;
        }
      }
    },
    goToNotifications() {
      this.$router.push('/notifications');
    },
  },
};
</script>
